<template>
  <div>
    <Head>
      <Title>{{ $t('pages.team.meta.title', useTeamParams()) }}</Title>
      <Meta name="description" :content="$t('pages.team.meta.description', useTeamParams())" />
    </Head>
    <div>
      <div class="space-y-8" v-auto-animate>
        <div class="space-y-3" v-if="fixtures?.length">
          <!-- <div class="font-bold">{{ $t('shared.nav.fixtures') }}</div> -->
          <PartialsGames :games="fixtures" />
        </div>
        <!-- <div class="space-y-3" v-if="results?.length">
          <div class="font-bold">{{ $t('shared.nav.results') }}</div>
          <PartialsGames :games="results" />
        </div> -->
      </div>
      <TeamSeoText type="start" class="mt-8" />
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'team'
})

const team = useTeamStore()
const league = useLeagueStore()

const { data } = useFetch(`/api/v1/teams/${team.slug}/games`, { 
  key: `team-games-${team.slug}`,
  baseURL: useEnv('apiBase'),
})

const now = useDate()

// 1. Fixtures: Games from the last 7 days (based on first game date)
const fixtures = computed(() => {
  const upcomingGames = data.value?.games?.filter(g => !now.isAfter(g.startDate)) || []

  return upcomingGames
    ?.filter(game => game.id !== team.featured?.id)
    ?.slice(0, 5)
  // const upcomingDate = upcomingGames[0]?.startDate
  // const weekBeforeLatest = useDate(upcomingDate).add(14, 'day')

  // return upcomingGames
  //   ?.filter(g => weekBeforeLatest.isAfter(g.startDate))
})

// 2. Results: Games from the last 7 days (based on last game date)
const results = computed(() => {
  const pastGames = (data.value?.games?.filter(g => now.isAfter(g.startDate)) || [])?.reverse()
  return pastGames.slice(0, 5)
})
</script>